"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");require("core-js/modules/es.array.for-each");require("core-js/modules/es.object.keys");require("core-js/modules/es.object.to-string");require("core-js/modules/es.promise");require("core-js/modules/web.dom-collections.for-each");exports.__esModule = true;exports.isXhr = isXhr;exports.default = void 0;var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _is = require("./is");


var _str = require("./str");
var _prepareRequestBody = _interopRequireDefault(require("./prepareRequestBody"));
var _json = require("./json");








































function isXhr(xhr) {
  return xhr instanceof XMLHttpRequest;
}


/**
   * Обёртка над XMLHttpRequest
   *
   *
   * @class Xhr
   */var
Xhr = /*#__PURE__*/function () {












  function Xhr(props) {(0, _defineProperty2.default)(this, "url", void 0);(0, _defineProperty2.default)(this, "xhr", void 0);(0, _defineProperty2.default)(this, "method", void 0);(0, _defineProperty2.default)(this, "body", void 0);(0, _defineProperty2.default)(this, "query", void 0);(0, _defineProperty2.default)(this, "headers", void 0);(0, _defineProperty2.default)(this, "onLoad", void 0);(0, _defineProperty2.default)(this, "onError", void 0);(0, _defineProperty2.default)(this, "onComplete", void 0);
    this.prepareMethod(props.method);
    this.prepareBody(props.body, props.sendAs);
    this.prepareUrl(props.url);
    this.prepareHeaders(props.headers);
    this.onLoad = props.onLoad;
    this.onError = props.onError;
    this.onComplete = props.onComplete;
    this.send();
  }Xhr.


  isXhr = function isXhr(maybeXhr) {
    return maybeXhr instanceof XMLHttpRequest;
  }



  /**
     * Загружает данные из json-файла
     *
     * @static
     * @param {string} filePath
     * @returns {Promise<LoadJSONreturnType>}
     * @memberof Xhr
     * @example
     * Xhr.loadJSON( './path/to/file.json' )
     *   .then( resp => {
     *     console.log( resp )
     *     // { hasErr: false, value: { x: 3 } }
     *     // or
     *     // { hasErr: true, error: 'parse error' | 'loading error' }
     *   } )
     */;Xhr.
  loadJSON = function loadJSON(filePath) {
    return new Promise(function (resolve) {
      var xhr = new XMLHttpRequest();
      function cb(err, value, responseText) {
        xhr.onload = function () {};
        xhr.onerror = function () {};
        if (!(0, _is.isNull)(err)) {
          resolve({ hasErr: true, error: err, responseText: (0, _str.castStr)(responseText) });
        } else {
          resolve({ hasErr: false, value: value, responseText: (0, _str.castStr)(responseText) });
        }
      }
      xhr.overrideMimeType('application/json');
      xhr.open('GET', filePath, true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          var resultJson = (0, _json.parse)(xhr.responseText);
          if (resultJson !== null) {
            cb(null, resultJson, xhr.responseText);
          } else {
            cb('parse error', null, xhr.responseText);
          }
        } else {
          cb('loading error');
        }
      };
      xhr.onerror = function () {
        cb('loading error');
      };
      xhr.send(null);

    });
  };var _proto = Xhr.prototype;_proto.



  prepareMethod = function prepareMethod(method) {
    this.method = (0, _is.isStr)(method) ? method : 'GET';
  };_proto.



  prepareBody = function prepareBody(body, sendAs) {var
    method = this.method;

    if (method === 'GET') {
      var query = (0, _prepareRequestBody.default)({ body: body, as: 'query' });
      this.query = (0, _is.isStr)(query) ? query : '';
      this.body = null;
      return;
    }

    this.query = '';

    var asFormData = sendAs === 'formData';

    this.body = (0, _prepareRequestBody.default)({ body: body, as: asFormData ? 'formData' : 'json' });
  };_proto.



  prepareUrl = function prepareUrl(url) {
    this.url = url + this.query;
  };_proto.



  prepareHeaders = function prepareHeaders(headers) {
    this.headers = (0, _is.isObj)(headers) ? headers : null;
  };_proto.


  send = function send() {var

    url =



    this.url,method = this.method,body = this.body,headers = this.headers;

    var xhr = new XMLHttpRequest();
    xhr.open(method, url);

    if ((0, _is.isObj)(headers)) {
      Object.keys(headers).forEach(function (headerKey) {
        var headerVal = headers[headerKey];
        xhr.setRequestHeader(headerKey, headerVal);
      });
    }

    xhr.onload = this._onLoad.bind(this);
    xhr.onerror = this._onError.bind(this);

    xhr.send(body);

    this.xhr = xhr;
  };Xhr.



  getResp = function getResp(trg, respEventType) {

    var defs = {
      type: respEventType,
      response: '',
      status: -1 };


    if (!(trg instanceof XMLHttpRequest)) return defs;

    return {
      type: respEventType,
      response: trg.responseText,
      status: trg.status };

  };_proto.


  _onLoad = function _onLoad(ev) {
    var resp = Xhr.getResp(ev.target, 'load');
    if ((0, _is.isF)(this.onLoad)) {
      var cb = this.onLoad;
      cb(resp);
    }
    this._onComplete(resp);
  };_proto.



  _onError = function _onError(ev) {
    var resp = Xhr.getResp(ev.target, 'error');
    if ((0, _is.isF)(this.onError)) {
      var cb = this.onError;
      cb(resp);
    }
    this._onComplete(resp);
  };_proto.


  _onComplete = function _onComplete(resp) {
    if ((0, _is.isF)(this.onComplete)) {
      var cb = this.onComplete;
      cb(resp);
    }
    this.destroy();
  };_proto.




  destroy = function destroy() {var
    xhr = this.xhr;

    if (isXhr(xhr)) {
      xhr.onload = function () {};
      xhr.onerror = function () {};
    }
    this.xhr = null;

    this.onLoad = null;
    this.onError = null;
    this.onComplete = null;
    this.headers = null;
    this.body = null;

  };return Xhr;}();exports.default = Xhr;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Xhr.js
// module id = 222
// module chunks = 0